var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearchAndReplaceIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.65766 6.89668H4.77824V2.0171H6.41839V4.05394C7.0309 3.21024 7.79417 2.48093 8.67697 1.9027C10.0781 0.984978 11.7076 0.5 13.3891 0.5C18.1372 0.5 22 4.36284 22 9.11088H20.3599C20.3599 5.26727 17.2327 2.14014 13.3891 2.14014C11.0381 2.14014 8.85962 3.33472 7.58028 5.25653H9.65766V6.89668ZM17.1204 12.9652H19.1984C17.9197 14.888 15.7438 16.0816 13.3891 16.0816C9.54551 16.0816 6.41839 12.9545 6.41839 9.11088H4.77824C4.77824 11.1903 5.51909 13.0998 6.75068 14.5895L1 20.3402L2.15981 21.5L7.91049 15.7493C9.40019 16.9809 11.3097 17.7218 13.3891 17.7218C16.1756 17.7218 18.7591 16.3686 20.3599 14.1667V16.2047H22V11.3251H17.1204V12.9652Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchAndReplaceIcon);
export default __webpack_public_path__ + "static/media/search-and-replace-icon.98e262910734a7132f75669c39abce57.svg";
export { ForwardRef as ReactComponent };